import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Pages/Home";
import "./App.css";
import HomeGym1 from "./Pages/HomeGym1";
import InventoryGym1 from "./Pages/InventoryGym1";
import PengeluaranGym1 from "./Pages/PengeluaranGym1";
import RekapanGym1 from "./Pages/RekapanGym1";
import PersonalTrainerGym1 from "./Pages/PersonalTrainerGym1";
import AttendanceGym1 from "./Pages/AttendanceGym1";
import AttendanceGym1MemberBaru from "./Pages/AttendanceGym1MemberBaru";
import AttendanceGym1MemberPerpanjangan from "./Pages/AttendanceGym1MemberPerpanjangan";
import HomeGym2 from "./Pages/HomeGym2";
import AttendanceGym2 from "./Pages/AttendanceGym2";
import AttendanceGym2MemberBaru from "./Pages/AttendanceGym2MemberBaru";
import AttendanceGym2MemberPerpanjangan from "./Pages/AttendanceGym2MemberPerpanjangan";
import InventoryGym2 from "./Pages/InventoryGym2";
import PengeluaranGym2 from "./Pages/PengeluaranGym2";
import RekapanGym2 from "./Pages/RekapanGym2";
import PersonalTrainerGym2 from "./Pages/PersonalTrainerGym2";
import Owner from "./Pages/Owner";
import OwnerCashFlow from "./Pages/OwnerCashFlow";
import OwnerDatabase from "./Pages/OwnerDatabase";
import OwnerPricing from "./Pages/OwnerPricing";
import OwnerInOut from "./Pages/OwnerInOut";

function App() {
  //const url="http://192.168.72.136/Uwaisqu/uwaisqu.php";
  //const url = "http://localhost/Kekes/gym.php";
const url = "https://monitoring.kekesgym.site/gym.php";
  //const url="http://localhost/Uwaisqu/uwaisqu.php";

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home url={url} />} />
        <Route path="/gym1" element={<HomeGym1 url={url} />} />
        <Route path="/gym1/inventory" element={<InventoryGym1 url={url} />}>
          <Route index element={<PengeluaranGym1 url={url} />} />
          <Route
            path="/gym1/inventory/rekapan"
            element={<RekapanGym1 url={url} />}
          />
          <Route
            path="/gym1/inventory/personalTrainer"
            element={<PersonalTrainerGym1 url={url} />}
          />
        </Route>
        <Route path="/gym1/attendance" element={<AttendanceGym1 url={url} />} />
        <Route
          path="/gym1/attendance/memberBaru"
          element={<AttendanceGym1MemberBaru url={url} />}
        />
        <Route
          path="/gym1/attendance/memberPerpanjangan"
          element={<AttendanceGym1MemberPerpanjangan url={url} />}
        />
        <Route path="/gym2" element={<HomeGym2 url={url} />} />
        <Route path="/gym2/attendance" element={<AttendanceGym2 url={url} />} />
        <Route
          path="/gym2/attendance/memberBaru"
          element={<AttendanceGym2MemberBaru url={url} />}
        />
        <Route
          path="/gym2/attendance/memberPerpanjangan"
          element={<AttendanceGym2MemberPerpanjangan url={url} />}
        />
           <Route path="/gym2/inventory" element={<InventoryGym2 url={url} />}>
          <Route index element={<PengeluaranGym2 url={url} />} />
          <Route
            path="/gym2/inventory/rekapan"
            element={<RekapanGym2 url={url} />}
          />
          <Route
            path="/gym2/inventory/personalTrainer"
            element={<PersonalTrainerGym2 url={url} />}
          />
        </Route>
          <Route path="/owner" element={<Owner url={url} />}>
          <Route index element={<OwnerCashFlow url={url} />} />
           <Route
            path="/owner/database"
            element={<OwnerDatabase url={url} />}
          />
            <Route
            path="/owner/pricing"
            element={<OwnerPricing url={url} />}
          />
          <Route
            path="/owner/inout"
            element={<OwnerInOut url={url} />}
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
